<template>
  <div class="accountdisplayWrapper" @click="retrieveSessionId">
    <div class="picture">
      <img :src="account.picture" />
    </div>
    <div class="content">
      <div class="entity ellipsis">
        {{ name }}
      </div>
      <div class="kind ellipsis">
        {{ kind }}
      </div>
    </div>
    <div class="delete" @click.stop="delete_self">
      <i class="fas fa-times" />
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex"

import cache_mixin from "~/mixins/cache"
import acc_swapper_mixin from "~/mixins/nav/accSwapperFromGuard"

export default {
  mixins: [cache_mixin, acc_swapper_mixin],
  computed: {
    name: function () {
      return this.account.first_name || this.account.email || this.account.name
    },
    kind: function () {
      const kind = this.account.kind.length ? this.account.kind : ""

      if (kind === "agency") return this.$t("common.PR")
      else if (kind === "influencer") return this.$t("common.inf")
      else if (kind === "band") return this.$t("common.AR")
      else return "Creature of darkness"
    },
  },
  methods: {
    delete_self: function () {
      this.$axios
        .$delete(`/auth/switch/${this.account.pk}/`)
        .then((resp) => {
          this.remove_account_by_id(this.account.pk)
        })
        .finally((error) => {
          this.loading = false
        })
    },
    retrieveSessionId: function () {
      this.prepareAccountSwap(this.account.pk, this.account.email)
    },
    ...mapMutations({
      remove_account_by_id: "REMOVE_ACCOUNT_BY_ID",
    }),
  },
  props: {
    account: {
      required: true,
      type: Object,
    },
  },
}
</script>
<style scoped src="./accountDisplay.css"></style>
